import { BehaviorSubject } from 'rxjs';

import ValidationException from '../exceptions/ValidationException';

export default class ErrorRepository {
  error$ = new BehaviorSubject(null);

  notifyException(exception) {
    let { message } = exception;
    if (exception instanceof ValidationException) {
      message = Object.values(exception.errors).map((error) => error.join('. '));
    }
    this.error$.next({ message: typeof message === 'string' ? message : message.join('. '), severity: 'error' });
  }
}
